export default __webpack_public_path__ + "static/media/Info.583b23a2.svg";